// constants
import { showSuccessAlert } from "../../constants/alerts";
import { CouponActionTypes } from "./constants";

const INIT_STATE = {
  Coupon: [],
  influencerCoupons: [],
  influencer: null,
  totalRevenue: [],
  loading: false,
  initialLoading: false,
  error: null,
};

interface CouponData {
  id: string;
  name: string;
  phone: string;
  email: string;
  coupon_code: string;
  expire_in: string;
}

interface CouponActionType {
  type:
    | CouponActionTypes.API_RESPONSE_SUCCESS
    | CouponActionTypes.API_RESPONSE_ERROR
    | CouponActionTypes.CREATE_COUPONS
    | CouponActionTypes.UPDATE_COUPONS
    | CouponActionTypes.GET_COUPONS
    | CouponActionTypes.GET_COUPONS_INFLUENCERS
    | CouponActionTypes.GET_COUPONS_REPORT
    | CouponActionTypes.DELETE_COUPONS;
  payload: {
    actionType?: any;
    data?: any;
    error?: string;
    Coupon?: [];
  };
}

interface State {
  Coupon?: CouponData[] | [];
  loading?: boolean;
  value?: boolean;
}

const Coupon = (state: State = INIT_STATE, action: CouponActionType): any => {
  switch (action.type) {
    case CouponActionTypes.API_RESPONSE_SUCCESS:
      switch (action.payload.actionType) {
        case CouponActionTypes.CREATE_COUPONS: {
          showSuccessAlert(action.payload.data);
          return {
            ...state,
            loading: false,
            error: null,
          };
        }
        case CouponActionTypes.GET_COUPONS: {
          return {
            ...state,
            loading: false,
            initialLoading: false,
            Coupon: action.payload.data,
          };
        }
        case CouponActionTypes.GET_COUPONS_INFLUENCERS: {
          return {
            ...state,
            loading: false,
            initialLoading: false,
            influencerCoupons: action.payload.data.couponDetails?.influencers,
            influencer: action.payload.data.influencer,
          };
        }
        case CouponActionTypes.GET_COUPONS_REPORT: {
          return {
            ...state,
            loading: false,
            initialLoading: false,
            totalRevenue: action.payload.data.paymentWithCoupons,
          };
        }
        case CouponActionTypes.UPDATE_COUPONS: {
          showSuccessAlert(action.payload.data);
          return {
            ...state,
            loading: false,
            error: null,
          };
        }
        case CouponActionTypes.DELETE_COUPONS: {
          showSuccessAlert(action.payload.data);
          return {
            ...state,
            loading: false,
            error: null,
          };
        }
        default:
          return { ...state };
      }

    case CouponActionTypes.API_RESPONSE_ERROR:
      switch (action.payload.actionType) {
        case CouponActionTypes.CREATE_COUPONS: {
          return {
            ...state,
            error: action.payload.error,
            loading: false,
          };
        }
        case CouponActionTypes.UPDATE_COUPONS: {
          return {
            ...state,
            loading: false,
            error: action.payload.error,
          };
        }
        case CouponActionTypes.GET_COUPONS: {
          return {
            ...state,
            error: action.payload.error,
            loading: false,
            initialLoading: false,
          };
        }
        case CouponActionTypes.GET_COUPONS_INFLUENCERS: {
          console.log(action.payload.error);
          return {
            ...state,
            error: action.payload.error,
            loading: false,
            initialLoading: false,
          };
        }
        case CouponActionTypes.DELETE_COUPONS: {
          return {
            ...state,
            error: action.payload.error,
            loading: false,
          };
        }
        default:
          return { ...state };
      }

    case CouponActionTypes.CREATE_COUPONS:
      return { ...state, loading: true };
    case CouponActionTypes.UPDATE_COUPONS:
      return { ...state, loading: true };
    case CouponActionTypes.GET_COUPONS:
      return { ...state, loading: true, initialLoading: true };
    case CouponActionTypes.GET_COUPONS_INFLUENCERS:
      return { ...state, loading: true, initialLoading: true };
    case CouponActionTypes.GET_COUPONS_REPORT:
      return { ...state, loading: true, initialLoading: true };
    case CouponActionTypes.DELETE_COUPONS:
      return { ...state, loading: true };
    default:
      return { ...state };
  }
};

export default Coupon;
